import { content } from "../../config/content.js";
import { buildAnimatedHeading } from "../HeroTitleAnimation.js";

function renderHighlight({ label, text }) {
  return `
    <div class="contact__highlight">
      <h3 class="contact__highlight-label">${label}</h3>
      <p class="contact__highlight-text">${text}</p>
    </div>
  `;
}

function renderSupportOptions(options) {
  return options
    .map(
      (option) =>
        `<option value="${option.value}"${option.value === "" ? " disabled selected" : ""}>${option.label}</option>`
    )
    .join("");
}

export function createContactSection() {
  const { contact } = content;
  const section = document.createElement("section");
  section.id = "contact";
  section.className = "section contact";

  section.innerHTML = `
    <div class="section__inner contact__layout reveal">
      <div class="contact__info">
        <h2 class="contact__title">${buildAnimatedHeading(contact.titleSegments)}</h2>
        <p class="contact__intro">${contact.intro}</p>
        <div class="contact__highlights">
          ${contact.highlights.map(renderHighlight).join("")}
        </div>
      </div>

      <form class="contact__form" novalidate>
        <label class="contact__field">
          <span class="sr-only">Name</span>
          <input type="text" name="name" placeholder="Name" autocomplete="name" required />
        </label>
        <label class="contact__field">
          <span class="sr-only">Company Name</span>
          <input type="text" name="company" placeholder="Company Name" autocomplete="organization" />
        </label>
        <label class="contact__field">
          <span class="sr-only">Work Email</span>
          <input type="email" name="email" placeholder="Work Email" autocomplete="email" required />
        </label>
        <label class="contact__field">
          <span class="sr-only">Phone Number</span>
          <input type="tel" name="phone" placeholder="Phone Number" autocomplete="tel" />
        </label>
        <label class="contact__field">
          <span class="sr-only">${contact.form.supportPlaceholder}</span>
          <select name="support" required>
            ${renderSupportOptions(contact.form.supportOptions)}
          </select>
        </label>
        <label class="contact__field">
          <span class="sr-only">Message</span>
          <textarea
            name="message"
            rows="5"
            placeholder="${contact.form.messagePlaceholder}"
            required
          ></textarea>
        </label>
        <button class="btn btn--primary contact__submit" type="submit">${contact.form.submitLabel}</button>
      </form>
    </div>
  `;

  bindForm(section, contact);
  return section;
}

function renderSuccess(success) {
  return `
    <div class="contact__form contact__success" role="status">
      <p class="contact__success-kicker">${success.kicker}</p>
      <h3 class="contact__success-title">${success.title}</h3>
      <p class="contact__success-body">${success.body}</p>
    </div>
  `;
}

function bindForm(section, contact) {
  const form = section.querySelector(".contact__form");
  const select = form.querySelector('select[name="support"]');

  select.addEventListener("change", () => {
    select.classList.toggle("contact__select--filled", select.value !== "");
  });

  form.addEventListener("submit", (event) => {
    event.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    form.outerHTML = renderSuccess(contact.success);
  });
}
